import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import { useWindowDimension } from "src/hooks";
import { ModalsAction, UserSession } from "src/store";
import { Close } from "../svg";
import { PromotionCardProps } from "./promotion.card.props";

export const PromotionCard: React.FC<PromotionCardProps> = ({
  closable,
  sliderSpeed,
  path,
  target,
  link,
  programId,
  ratio,
  mobile,
  desktop,
  items,
  onclose,
}) => {
  const dispatch = useDispatch();
  const [width] = useWindowDimension();
  const user: UserSession = useSelector((state: any) => state.UserState);

  const calcWidth = useCallback(() => {
    const per = width > 760 ? desktop : mobile;

    let w =
      document.querySelector(".archive-list-area:not(.archive-promotions-area)")
        ?.clientWidth || 760;

    if (per > 1) w -= (items - 1) * 10;
    if (width <= 760 && items > per) w -= 30;

    let result = Math.floor(w / per);
    return result;
  }, [items, mobile, desktop, width]);

  const [cardWidth, setCardWith] = useState(calcWidth());

  const getPath = () => {
    if (target === "link") return link?.href as string;
    if (target === "archiveprogram") return `/archive/${programId}/`;
    if (target === "liveprogram") return `/program/${programId}/`;
    if (target === "editprofile") return "/profile/edit";
    if (target === "favorite") return "/profile/favorites";
    if (target === "packagelist") return "/subscription";
    if (target === "packageprofile") return `/${link?.href}`;
    if (target === "antenapps") return "/download";
    return link?.href || "";
  };

  const clickPromotion = (e?: React.MouseEvent<HTMLAnchorElement>) => {
    if (
      !user.loggedIn &&
      (target === "editprofile" ||
        target === "favorite" ||
        target === "withoutlink")
    ) {
      e?.stopPropagation();
      e?.preventDefault();
      if (target === "editprofile")
        dispatch(ModalsAction.showLoginPermission("/profile/edit"));
      if (target === "favorite")
        dispatch(ModalsAction.showLoginPermission("/profile/favorites"));
      if (target === "withoutlink") return false;
    }
  };

  const close = (e: React.MouseEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    onclose && onclose();
  };

  useEffect(() => {
    setCardWith(calcWidth());
  }, [width, setCardWith, desktop, mobile, items, calcWidth]);

  return target !== "antenapps" ? (
    <NavLink
      target={target === "link" ? "_blank" : "_self"}
      to={{
        pathname: getPath(),
      }}
      onClick={clickPromotion}
      className={"promotion-card"}
      style={{
        width: cardWidth,
        height: cardWidth * ratio,
        backgroundImage: `url(${path})`,
        animationDuration: `${+sliderSpeed * 3}s`,
        cursor: target === "withoutlink" ? "default" : "pointer",
      }}
    >
      {closable && (
        <span onClick={close} className="close-button">
          <Close />
        </span>
      )}
    </NavLink>
  ) : (
    <a
      className={"promotion-card"}
      style={{
        width: cardWidth,
        height: cardWidth * ratio,
        backgroundImage: `url(${path})`,
        animationDuration: `${+sliderSpeed * 3}s`,
      }}
      href={getPath()}
    ></a>
  );
};
